import { FiEdit } from "@react-icons/all-files/fi/FiEdit";
import { MdPayment } from "@react-icons/all-files/md/MdPayment";
import React from "react";
import { FaRegIdCard } from "react-icons/fa";
import NumberSeparator from "../../../Utilities/NumberSeparator";
import MemberDueCalc from "./MemberDueCalc";

class MemberTableConfig {
    constructor() {
    }

    static allColumn({ setMemberIdCardModelShow, setIdData, currentPage, setGetSingleMemberData, setEditMemberModelShow, setDonationModelShow }) {
        return [
            {
                dataField: 'id',
                text: 'SL',
                // sort: true,
                headerStyle: (colum, colIndex) => {
                    return {
                        width: '50px',
                        textAlign: "center"
                    };
                },
                style: {
                    textAlign: "center"
                },
                formatter: (cell, row, rowIndex) => {
                    return rowIndex + 1
                }

            },
            {
                dataField: 'id',
                text: 'ID',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return {
                        width: '50px',
                        textAlign: "center"
                    };
                },
                style: {
                    textAlign: "center"
                },
                formatter: (cell, row, rowIndex) => {
                    return cell
                }

            },
            {
                dataField: 'member_name',
                text: 'Name',
                sort: true,
                headerClasses: 'mobile-col-header',
                headerStyle: (colum, colIndex) => {
                    return {
                        width: '160px'

                    };
                },
                style: {
                    // textAlign: "center"
                },
                formatter: (cell, row) => {
                    // return `${row.member_name} (${row.id})`;
                    return `${row.member_name}`;
                }
            },
            {
                dataField: 'village',
                text: 'Village',
                // sort: true,
                headerStyle: (colum, colIndex) => {
                    return {
                        width: '100px',
                        textAlign: "center"
                    };
                },
                style: {
                    textAlign: "center"
                }
            },
            {
                dataField: 'police_station',
                text: 'P.S',
                // sort: true,
                headerStyle: () => {
                    return {
                        width: '100px',
                        textAlign: "center"
                    }
                },
                style: {
                    textAlign: "center"
                }
            }, {
                dataField: 'district',
                text: 'District',
                // sort: true,
                headerStyle: () => {
                    return {
                        width: '100px',
                        textAlign: "center"
                    }
                },
                style: {
                    textAlign: "center"
                }
            },
            {
                dataField: 'mobile',
                text: 'Phone No.',
                sort: false,
                headerStyle: (colum, colIndex) => {
                    return {
                        width: '100px',
                        textAlign: "center"
                    };
                },
                style: {
                    textAlign: "center"
                }
            },
            {
                dataField: 'grade',
                text: 'Grade.',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return {
                        width: '60px',
                        textAlign: "center"
                    };
                },
                style: {
                    textAlign: "center"
                }
            },
            {
                dataField: 'agent_id',
                text: 'Coll. ID',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return {
                        width: '60px',
                        textAlign: "center"
                    };
                },
                style: {
                    textAlign: "center"
                },
                formatter: (cell, row, rowIndex) => {
                    return <>
                        {row.user?.id}
                    </>
                }
            },
            {
                dataField: 'id',
                headerClasses: 'mobile-action-member',
                text: 'Action',
                headerStyle: () => {
                    return {

                        textAlign: 'center'
                    }
                },
                style: { textAlign: "center" },
                formatter: ((cell, row) => {
                    return row.member_name != "Loading..." ? <>
                        {/*Add donation*/}
                        <button title="PAYMENT"
                            className="btn btn btn-sm btn-warning mx-2"
                            onClick={e => {
                                //single data for update
                                setGetSingleMemberData(row)

                                // Donation model open
                                setDonationModelShow(true)
                            }
                            }>
                            Payment
                        </button>
                        {/*edit member*/}
                        <button title="EDIT"
                            className="btn btn-sm btn-success"
                            onClick={e => {
                                //single data for update
                                setGetSingleMemberData(row)
                                // update model open
                                setEditMemberModelShow(true)

                            }
                            }>
                            Edit
                        </button>

                        {/*id card*/}
                        {/* <button title="ID CARD"
                        className="bg-transparent iconActionButton border-0 text-success btn btn-primary"
                        onClick={e => {
                            //single data for id card
                            setIdData(row)

                            // card model open
                            setMemberIdCardModelShow(true)
                        }
                        }>
                        <FaRegIdCard />
                    </button> */}
                    </> : "Loading..."
                })

            }]
    }
}

export default MemberTableConfig